/*
 * Promo banner countdown.
 *
 * Deliberately not reusing the `.countdown` class from the announcement bar:
 * that section runs its own global querySelectorAll('.countdown') loop and
 * would overwrite this element's markup with its own format.
 */
if (!customElements.get('promo-countdown')) {
  class PromoCountdown extends HTMLElement {
    connectedCallback() {
      this.endTime = Date.parse(this.dataset.end);

      if (Number.isNaN(this.endTime)) {
        this.hidden = true;
        return;
      }

      this.banner = this.closest('.promo-banner');
      this.hideOnEnd = this.dataset.hideOnEnd === 'true';
      this.autoHideDays = this.dataset.autoHideDays === 'true';
      this.units = {
        days: this.querySelector('[data-unit="days"]'),
        hours: this.querySelector('[data-unit="hours"]'),
        minutes: this.querySelector('[data-unit="minutes"]'),
        seconds: this.querySelector('[data-unit="seconds"]')
      };

      this.tick();
      this.timer = setInterval(this.tick.bind(this), 1000);
    }

    disconnectedCallback() {
      clearInterval(this.timer);
    }

    tick() {
      const distance = this.endTime - Date.now();

      if (distance <= 0) {
        clearInterval(this.timer);
        this.render(0, 0, 0, 0);
        this.ended();
        return;
      }

      const seconds = Math.floor(distance / 1000);
      this.render(
        Math.floor(seconds / 86400),
        Math.floor((seconds % 86400) / 3600),
        Math.floor((seconds % 3600) / 60),
        seconds % 60
      );
    }

    render(days, hours, minutes, seconds) {
      this.setUnit(this.units.days, days, this.autoHideDays && days === 0);
      this.setUnit(this.units.hours, hours);
      this.setUnit(this.units.minutes, minutes);
      this.setUnit(this.units.seconds, seconds);
    }

    setUnit(element, value, hide = false) {
      if (!element) return;

      element.hidden = hide;

      const separator = element.nextElementSibling;
      if (separator && separator.classList.contains('promo-banner__cd-sep')) {
        separator.hidden = hide;
      }

      if (hide) return;

      const target = element.querySelector('[data-value]');
      const formatted = String(value).padStart(2, '0');
      if (target && target.textContent !== formatted) {
        target.textContent = formatted;
      }
    }

    ended() {
      if (!this.hideOnEnd || !this.banner) return;

      // Shopify re-renders the section on every editor change, so hiding is
      // enough here -- the merchant still sees it back in the theme editor.
      this.banner.hidden = true;
    }
  }

  customElements.define('promo-countdown', PromoCountdown);
}
